import { T } from '@tribeplatform/react-components/i18n'

import { GeneralSettings } from '../GeneralSettings.js'

export function CommunityGeneralSettingsRouter() {
  return <GeneralSettings />
}

export function CommunityGeneralSettingsBreadCrumb() {
  return <T id="Generics.General" defaultMessage="General" />
}
